<script lang="ts">
  import Ellipse from "./ellipse.svg?icon"
</script>

<div {...$$restProps}>
  <Ellipse />
</div>

<style lang="postcss">
  * {
    @apply aspect-[336/389] h-full w-auto text-white transition-[color];

    mask: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.29));

    & > :global(*) {
      @apply h-full w-full;
    }
  }
</style>
